import React from "react";

import I24Tick from "assets/icons/I24Tick";
import I32ArrowRight from "assets/icons/I32ArrowRight";
import I64FLogo from "assets/icons/I64FLogo";
import I196TextLogo from "assets/icons/I196TextLogo";

import Button from "components/Button";

import { LINKS } from "constants/links";
import styleConst from "constants/style";

import {
  ButtonWrapper,
  Container,
  Content,
  IconWrapper,
  Logo,
  TextLogo,
  Text,
  Possibilities,
  Possibility,
  PossibilityTitle,
} from "./styles";

type Props = { onClose: () => void };

const PromoteContentPopup = ({ onClose }: Props) => {
  const possibilities = ["Recipes", "Workouts", "Resources"];

  const onClick = () => {
    onClose();
    window.open(LINKS.MAIN_PAGE);
  };

  return (
    <Container>
      <Content top>
        <Logo>
          <IconWrapper>
            <I64FLogo />
          </IconWrapper>
          <TextLogo>
            <I196TextLogo color={styleConst.colors.white} />
          </TextLogo>
        </Logo>
        {/* TODO TRANSLATE THIS LINE ABOVE */}
        <Text>Get unlimited access to FASTer exclusive</Text>
      </Content>
      <Content bottom>
        <Possibilities>
          {possibilities.map(title => (
            <Possibility key={title}>
              <IconWrapper contentIcon>
                <I24Tick />
              </IconWrapper>
              <PossibilityTitle>{title}</PossibilityTitle>
            </Possibility>
          ))}
        </Possibilities>
        <ButtonWrapper>
          <Button
            text={"Learn more"}
            onClick={onClick}
            iconRight={<I32ArrowRight />}
            height={50}
          />
        </ButtonWrapper>
      </Content>
    </Container>
  );
};

export default PromoteContentPopup;
